import { inject, Injectable } from '@angular/core';
import { getPreference, Preference, setPreference } from '../../../utils/preferences.storage';
import { HighlightsBase, NewsHighlight } from './highlights';
import { BehaviorSubject } from 'rxjs';
import { SHORT_LOCALE_ID } from '../../../shared/initialize.provider';
import { HighlightsTranslationsEn } from './highlights.en';
import { HighlightsTranslationsFr } from './highlights.fr';

@Injectable({
  providedIn: 'root',
})
export class HighlightService {
  private unreadSubject = new BehaviorSubject<number>(this.checkUnread());
  unread$ = this.unreadSubject.asObservable();
  locale = inject(SHORT_LOCALE_ID);

  checkUnread(): number {
    const lastSeenId = getPreference<number>(Preference.LAST_SEEN_HIGHLIGHT);
    if (lastSeenId !== this.getLatestReleaseId()) {
      const diff = this.getLatestReleaseId() - lastSeenId;
      return diff > 0 ? diff : 0;
    }
    return 0;
  }

  markAsRead(): void {
    setPreference(Preference.LAST_SEEN_HIGHLIGHT, this.getLatestReleaseId());
    this.unreadSubject.next(0);
  }

  getLatestReleaseId(): number {
    return HighlightsBase.length;
  }

  get highlights(): NewsHighlight[] {
    const translations =
      this.locale === 'en' ? this.highlightsTranslationsEn : this.highlightsTranslationsFr;
    return this.highlightsBase.map(
      (highlight, index) =>
        ({
          ...highlight,
          ...translations[index],
        }) as NewsHighlight
    );
  }

  private get highlightsBase(): Partial<NewsHighlight>[] {
    return HighlightsBase;
  }

  private get highlightsTranslationsEn(): Partial<NewsHighlight>[] {
    return HighlightsTranslationsEn;
  }

  private get highlightsTranslationsFr(): Partial<NewsHighlight>[] {
    return HighlightsTranslationsFr;
  }
}
